import { render } from "./PublicBooking.vue?vue&type=template&id=2cd37f77&scoped=true"
import script from "./PublicBooking.vue?vue&type=script&lang=js"
export * from "./PublicBooking.vue?vue&type=script&lang=js"

import "./PublicBooking.vue?vue&type=style&index=0&id=2cd37f77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd37f77"]])

export default __exports__